import { Card } from '@ipfabric/ui-components/Card/Card';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { storedAimFlows } from '../../../snippets/storedAimFlows';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const aimFlowsGroup = createFormSnippetGroup({
  snippets: {
    aimFlows: storedAimFlows,
  },
  render: ({ renderSnippet }) => (
    <SearchableSection
      id='aim-flows'
      searchTerms={['Flow list']}
      highlightOn={['aimFlows']}
      className='flex flex-col flex-1'
      wrapperClassName='flex flex-col flex-1'
    >
      <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
        <SearchableSection
          id='aim-flows'
          className='flex flex-col flex-1'
          wrapperClassName='flex flex-col flex-1'
          highlightOn={['applicationMapping']}
        >
          {renderSnippet('aimFlows')}
        </SearchableSection>
      </Card>
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('applicationMapping');
    control.setApplicationMappingSubTab('aimFlows');
  },
});
